module.exports = __webpack_public_path__ + "img/onboarding2.8ab6b7e8.png";